import { Clock, Sparkles } from 'lucide-react';

/**
 * Full-page "Coming Soon" placeholder used to override a route on
 * production (see REACT_APP_COMING_SOON_FEATURES in App.js) while the real
 * feature is still in development on dev. Visually matches the inline
 * ComingSoonDisplay already used inside MockInterview.js.
 */
export default function ComingSoon({ title, isDarkMode }) {
    return (
        <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-surface' : 'bg-surface'}`}>
            <div className="flex flex-col items-center justify-center text-center p-10 md:p-16 max-w-md">
                <div className={`mb-6 flex h-16 w-16 items-center justify-center rounded-full ${isDarkMode ? 'bg-blue-400/10' : 'bg-blue-500/10'}`}>
                    <Clock size={30} className={isDarkMode ? 'text-blue-400' : 'text-blue-600'} />
                </div>

                <div className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-4 border ${
                    isDarkMode ? 'bg-blue-400/10 text-blue-400 border-blue-400/30' : 'bg-blue-500/10 text-blue-700 border-blue-500/30'
                }`}>
                    <Sparkles size={12} />
                    Coming Soon
                </div>

                <h2 className={`text-xl md:text-2xl font-bold mb-2 ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>
                    {title} is under construction
                </h2>
                <p className={`text-sm md:text-base ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                    We're still building this part of the app. Check back soon &mdash; it'll be ready before you know it.
                </p>
            </div>
        </div>
    );
}
